import styled from "styled-components";

export default styled.div`
  width: 100%;
  min-width: 100%;
  height: 360px;
  overflow: hidden;
  position: relative;
  left: 50%;
  right: 50%;
  margin-left: -50%;
  margin-right: -50%;
  background-image: url(/assets/about/banner.png);
  background-position: center;
  position: relative;
  user-select: none;
  > p {
    color: #fff;
    position: absolute;
    left: 28%;
    top: 192px;
    font-size: 16px;
    font-weight: 400;
  }
  > p:nth-child(1) {
    top: 140px;
    font-size: 30px;
    font-weight: 800;
  }
`;
